import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Stack, Checkbox, FormControlLabel } from "@mui/material";
const moment = require("moment");
import Download from "../../images/Download.svg";
import Print from "../../images/Print.svg";
import API from "../comman/API";
import { authHeader } from "../comman/MainFunction";
import { GET_ATTACHMENT_BY_BILLING_PROJECT_ID_URL } from "../../constants/ApiRoute";
import {
  deCryptFun,
  enCryptFun,
  zipAndDownload,
} from "../comman/CustomFunction";
import { useToast } from "../comman/CustomMessages";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function CreateBillingPeriodInvoice(props) {
  const {
    open,
    setCreateBillingPeriodModel,
    selectedInvoicePeriod,
    createBillingInvoice,
    createCloseBillingPeriod
  } = props;

  console.log("selectedInvoicePeriod", selectedInvoicePeriod);

  // const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const showToast = useToast();

  return (
    <>
      <Dialog
        className="user-filter-popup user-filter create-bill-popup"
        sx={{ maxWidth: "100%" }}
        fullScreen={fullScreen}
        open={open}
        aria-labelledby="responsive-dialog-title"
      >
        <Stack
          sx={{ p: "26px 32px", pb: "6px" }}
          direction="row"
          alignItems="center"
          spacing={2}
          justifyContent="space-between"
        >
          <Typography className="model-title">
            {" "}
            {selectedInvoicePeriod.ProjectName} - Billing Period (
            {/* {selectedInvoicePeriod.BillingDate} */}
            {moment.utc(selectedInvoicePeriod.BillingStart).local().format("MM/DD/YYYY")} -{" "}
            {moment.utc(selectedInvoicePeriod.BillingEnd).local().format("MM/DD/YYYY")})
          </Typography>
        </Stack>
        <Box sx={{ p: "0px 34px 0px 32px" }}>
          <Typography className="invoice-filter-subtitle">
            Billing Statements in Selected Period
          </Typography>
        </Box>

        <Stack
          sx={{ p: "23px 0px", pb: "3px" }}
          direction="row"
          alignItems="center"
          spacing={2}
          justifyContent="space-between"
        >
          <Box sx={{ p: "0px 34px 0px 32px" }}>
            <Typography className="model-title">
              No invoice found for the selected period.
            </Typography>
          </Box>
        </Stack>

        <Box sx={{ p: "0px 32px 0px 32px" }}>
          <Typography className="invoice-filter-subtitle">
            Click the create button below to create an invoice for the selected
            project in the selected period.
          </Typography>
        </Box>

        <DialogActions
          sx={{ justifyContent: "flex-start", p: "26px 32px", pt: "23px" }}
        >
          <Button
            className="filter-btn"
            onClick={() => createBillingInvoice(selectedInvoicePeriod)}
          >
            Create
          </Button>
          <Button
            className="cancel-btn"
            onClick={createCloseBillingPeriod}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
